import {LexicalEditor} from 'lexical';
import {updateEditorSelection} from './common';

export const formatWithSymbols = (text: string) => `<<${text}>>`;

export const insertIdTreeContent = async (
    editor: LexicalEditor,
    fieldName: string,
    fieldFormTitle?: string
) => {
    return new Promise((_, reject) => {
        if (!editor) {
            reject('Editor instance is missing');
        }

        const valuesToFormat = fieldFormTitle ? `${fieldName}.${fieldFormTitle}` : fieldName;
        updateEditorSelection(editor, formatWithSymbols(valuesToFormat));
    });
};
